import React from "react";
import { ReactComponent as Dot } from '../assets/icons/svg/dot.svg';

const FooterTopMenu = () => {
  const topMenu = [
    { name: '개인정보 처리방침', link: '' },
    { name: '이용약관', link: '' },
    { name: '인스타그램', link: 'https://www.instagram.com/wow_cruise?igsh=YmNndDVnZXByOTV1' },
    { name: '네이버블로그', link: 'https://blog.naver.com/wowcruise' },
    { name: '스마트 스토어', link: 'https://smartstore.naver.com/wowcruise' },
    { name: '유튜브', link: 'https://www.youtube.com/@wowcruise' },
  ];

  return (
    <div className="footer-top-menu">
      {topMenu.map((item, index) => (
        <React.Fragment key={item.name}>
          <a href={item.link} className="menu-link" target="_blank">{item.name}</a>
          {index < topMenu.length - 1 && <Dot />}
        </React.Fragment>
      ))}
    </div>
  );
};
const FooterBottom = () => {
  const topMenu = [
    { name: '운영시간', value: '평일 09:00~17:30 (토/일/공휴일 휴무)' }, 
    { name: '대표번호', value: '1660-0696' }, 
    { name: '메일', value: 'help@wowcruise.co.kr' }, 
    { name: '대표', value: '문희영' }, 
    { name: '사업자등록번호', value: '615-88-02623' }, 
    { name: '주소', value: '서울특별시 구로구 디지털로34길 55 코오롱싸이언스밸리2차 비201-에프12' }, 
    { name: '통신판매업신고', value: '제2023-서울구로-0637호' }, 
    { name: '관광사업자등록', value: '종합여행업 제2023-000007호(구로구청)' }, 
    { name: '개인정보보호 책임자', value: '김아람' }, 
  ];

  return (
    <div className="footer-bottom">
      {topMenu.map((item, index) => (
        <React.Fragment key={item.name}>
          <div className="footer-bottom-item">
            <span>{item.name}</span> :<span style={{marginLeft:'3px'}}>{item.value}</span>
            {/* {index < topMenu.length - 1 && ','} */}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <h1>(주)와우크루즈</h1>
        <FooterTopMenu /> 
      </div>

      <div className="footer-divider" />

      <FooterBottom />
    </footer>
  );
}

export default Footer;
